import type { VirtualAppointmentDto } from '../../services/virtualAppointments';
import {
    VA_CARD_LIST_CLASS,
    VirtualAppointmentAccordionItem
} from './VirtualAppointmentAccordionItem';
import {
    VirtualAppointmentDetailPrompt,
    VirtualAppointmentReadOnlyDescription
} from './VirtualAppointmentDetailPanels';
import { useExpandedKeys } from './useExpandedKeys';
import { formatClosedLabel, summaryFromDto } from './virtualAppointmentSummary';

interface PastVirtualAppointmentListProps {
    /** Done before this round, or canceled; most recently closed first. */
    past: readonly VirtualAppointmentDto[];
}

// Read-only record of closed VAs: each folded card opens onto its description, no controls.
export function PastVirtualAppointmentList({ past }: PastVirtualAppointmentListProps) {
    const { isExpanded, toggle } = useExpandedKeys();

    if (past.length === 0) {
        return <VirtualAppointmentDetailPrompt message="No past VAs" />;
    }
    return (
        <div className={VA_CARD_LIST_CLASS}>
            {past.map((va) => (
                <VirtualAppointmentAccordionItem
                    key={va.id}
                    summary={summaryFromDto(va)}
                    expanded={isExpanded(va.id)}
                    onToggle={() => toggle(va.id)}
                    done={va.status === 'done'}
                    meta={formatClosedLabel(va)}
                    team={va.team}
                >
                    <VirtualAppointmentReadOnlyDescription doc={va.descriptionDoc} layout="plain" />
                </VirtualAppointmentAccordionItem>
            ))}
        </div>
    );
}
